import { MMCC_RTC_SIGNAL } from './mmccMessageTypes'

export default class RTCPeer {
  // Perfect negotiation
  // https://developer.mozilla.org/en-US/docs/Web/API/WebRTC_API/Perfect_negotiation

  config = {
    iceServers: [{
      urls: 'stun:turn.jamieforth.net'
    }, {
      // Use turn rest api instead.
      // https://stackoverflow.com/questions/35766382/coturn-how-to-use-turn-rest-api/54725092
      urls: 'turn:turn.jamieforth.net',
      username: process.env.VUE_APP_TURN_USER,
      credential: process.env.VUE_APP_TURN_PASS
    }]
  }

  channel = null
  makingOffer = false
  ignoreOffer = false

  constructor (
    peer,
    me,
    caller,
    signaler,
    onOpenCallback,
    onCloseCallback,
    onMessageCallback
  ) {
    this.peer = peer
    this.me = me
    this.caller = caller
    this.signaler = signaler
    this.onOpenCallback = onOpenCallback
    this.onCloseCallback = onCloseCallback
    this.onMessageCallback = onMessageCallback
    this.polite = caller
    console.log(this.peer)
    this.peerConnection = new RTCPeerConnection(this.config)
    console.log(`rtc created for ${this.peer.channel_name}`)

    // Set up handlers.
    this.peerConnection.onnegotiationneeded = async () => {
      try {
        console.log('onnegotiationneeded')
        // Create an offer and send it to peer.
        this.makingOffer = true
        await this.peerConnection.setLocalDescription()
        this.sendSignal({ description:
                          this.peerConnection.localDescription })
      } catch (error) {
        console.error(error)
        throw (error)
      } finally {
        this.makingOffer = false
      }
    }

    this.peerConnection.onicecandidate = ({ candidate }) => {
      // On ICE candidate, send it to peer.
      console.log('onicecandidate', candidate)
      this.sendSignal({ candidate: candidate })
    }

    this.peerConnection.ondatachannel = (event) => {
      // Set receiver's data channel.
      this.channel = event.channel

      // Set up receiver handlers.
      this.channel.onmessage = (message) => {
        // console.log('onmessage', message)
        this.onMessageCallback(message)
      }

      // Set up receiver's channel status change callbacks.
      this.channel.onopen = this.onOpen.bind(this)
      this.channel.onclose = this.onClose.bind(this)
    }

    // If we are the caller, create the data channel. Receiver will
    // create the channel in response to our request (ondatachannel).
    if (caller) {
      console.log(`create data channel: ${this.peer.channel_name}`)
      this.channel = this.peerConnection.createDataChannel(this.peer.channel_name)

      this.channel.onmessage = (message) => {
        // console.log('onmessage', message)
        this.onMessageCallback(message)
      }

      // Set up callers channel status change callbacks.
      this.channel.onopen = this.onOpen.bind(this)
      this.channel.onclose = this.onClose.bind(this)
    }
  }

  onOpen (event) {
    if (event.target) {
      console.log(`Channel's status has changed to \
${event.target.readyState}`)

      // Call callback.
      this.onOpenCallback(this.peer)
    }
  }

   onClose (event) {
     console.log('onclose', `${this.peer.short_name}`)
     if (event.target) {
       console.log(`Channel's status has changed to \
${event.target.readyState}`)

       // Stop streaming
       this.onCloseCallback(this.peer)
     }
   }

  // Incoming RTC signals via WebSocket.
  async onSignal ({ data: { description, candidate } }) {
    try {
      if (description) {
        const offerCollision = (description.type === 'offer') &&
              (this.makingOffer ||
               this.peerConnection.signalingState !== 'stable')

        this.ignoreOffer = !this.polite && offerCollision
        if (this.ignoreOffer) {
          return
        }

        await this.peerConnection.setRemoteDescription(description)
        if (description.type === 'offer') {
          await this.peerConnection.setLocalDescription()
          this.sendSignal({ description:
                            this.peerConnection.localDescription })
        }
      } else if (candidate) {
        try {
          await this.peerConnection.addIceCandidate(candidate)
        } catch (error) {
          if (!this.ignoreOffer) {
            throw error
          }
        }
      }
    } catch (error) {
      console.error(error)
      throw error
    }
  }

  sendSignal (data) {
    this.signaler.sendObj({
      type: MMCC_RTC_SIGNAL,
      channel_name: this.peer.channel_name,
      from: this.me,
      data: data
    })
  }

  close () {
    console.log('close')
    this.channel.close()
  }

  send (data) {
    if (this.channel &&
        this.channel.readyState === 'open') {
      // console.log('sending to', this.peer, data)
      this.channel.send(data)
    }
  }
}
